import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M12.75 0C8.18893 0 4.5 3.756 4.5 8.4C4.5 13.044 12.75 24 12.75 24C12.75 24 21 13.044 21 8.4C21 3.756 17.3111 0 12.75 0ZM12.75 11.064C11.4536 11.064 10.3929 9.984 10.3929 8.664C10.3929 7.344 11.4536 6.264 12.75 6.264C14.0464 6.264 15.1071 7.344 15.1071 8.664C15.1071 9.984 14.0464 11.064 12.75 11.064Z' />
        </SvgIcon>
    );
});
